import { render, staticRenderFns } from "./component-third-link.vue?vue&type=template&id=7aaf8d28&scoped=true&"
import script from "./component-third-link.vue?vue&type=script&lang=js&"
export * from "./component-third-link.vue?vue&type=script&lang=js&"
import style0 from "./component-third-link.vue?vue&type=style&index=0&id=7aaf8d28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaf8d28",
  null
  
)

export default component.exports